module.exports = __webpack_public_path__ + "media/images/ai_brain_topics/return-05ca02b4be724ba051a4be00ae9494ee.png";